import store from '../../store'
import { WidgetListItems } from '../../util/sidebar'

/** Run after the watchlist row highlight has had a chance to paint. */
export function deferAfterWatchlistHighlightPaint(fn: () => void) {
    requestAnimationFrame(() => {
        requestAnimationFrame(fn)
    })
}

/** Run after the pane selection border has had a chance to paint. */
export function deferAfterPaneSelectionPaint(fn: () => void) {
    requestAnimationFrame(() => {
        requestAnimationFrame(() => {
            const watchlistOpen = store.getState().commonStore.rightSideWidget === WidgetListItems.WATCHLIST
            if (watchlistOpen) {
                requestAnimationFrame(fn)
            } else {
                fn()
            }
        })
    })
}
